import { useController } from 'react-hook-form';

import { FormFieldWrapper } from 'components/shared/BaseFormComponents';
import { Wysiwyg } from 'components/shared/Wysiwyg';

import { IHookWysiwygProps } from './types';

export const HookWysiwyg = ({ name, control, placeholder, defaultValue, helpText = '' }: IHookWysiwygProps) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control, defaultValue });

  return (
    <FormFieldWrapper helpText={helpText} errorMessage={error?.message}>
      <Wysiwyg
        type="secondary"
        data={value}
        onChange={(val) => {
          const text = val?.data?.text;
          if (!text) return onChange(null);

          onChange({
            text,
            raw: val?.data?.raw,
          });
        }}
        placeholder={placeholder}
      />
    </FormFieldWrapper>
  );
};
